import DeliveryTicketsList from "./DeliveryTicketsList";

export default {
  list: DeliveryTicketsList,
};
